import { render, staticRenderFns } from "./campaignComponents.vue?vue&type=template&id=622f33a6&scoped=true&lang=pug&"
import script from "./campaignComponents.vue?vue&type=script&lang=js&"
export * from "./campaignComponents.vue?vue&type=script&lang=js&"
import style0 from "./campaignComponents.vue?vue&type=style&index=0&id=622f33a6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622f33a6",
  null
  
)

export default component.exports